// import KaunJeetaCons from "components/vidhansabha/KaunJeetaCons";
import { stateData } from "../../../../../../constants/state";
import KaunJeetaConsD from "components/vidhansabha/KaunJeetaConsD";

export default function Index(props) {
  return <KaunJeetaConsD {...props} />;
}

export async function getServerSideProps(ctx) {
  //const { contentType, recordPerPage } = ctx.query;
  // const state = "haryana"
  const { consId, constituency, electionState } = ctx.params;

  console.log(electionState, " ", constituency, " ", consId, " plm ");

  let newName = constituency.split("-").slice(0, -2).join(" ");
  let ConstituencyListData2019 = [];
  let ConstituencyListData2024 = [];
  let constituencyArray = [];

  const masterKey = stateData[electionState]["masterConfigKey"];

  const masterConfig = await fetch(
    // `https://static.thelallantop.com/json-configs/public/file.json`
    `${process.env.NEXT_PUBLIC_APP_API_URL}/v1/staticData/json/master-config`
  ).then(async (res) => {
    return await res.json();
  });
  // masterConfigData = masterConfig?.data;
  const masterConfigData = masterConfig?.result?.jsonData?.data?.[masterKey];
  // console.log("master config data in ssr  ", masterConfigData);

  //making state dynamic based on the election state
  //also making the urls dynamic based on the election state
  const state = stateData[electionState]["result"]["constituency"]["state"];
  const stateHindi =
    stateData[electionState]["result"]["constituency"]["stateHindi"];
  let url = `${stateData[electionState]["result"]["constituency"]["url"]}/${consId}.json`;
  // let url3 = `${stateData[electionState]['result']['constituency']['url3']}/${consId}.json`
  let url3Key = stateData[electionState]["result"]["constituency"]["url3Key"];
  let url3 = `${masterConfigData[url3Key]}${consId}.json`;
  let url2 = `${stateData[electionState]["result"]["constituency"]["url2"]}`;
  const tabs = stateData[electionState]["result"]["constituency"].tabs;
  // const masterKey = stateData[electionState]['masterConfigKey']
  const cYear = stateData[electionState]["result"]["currentYear"];
  const breadCrump = stateData[electionState]["breadCrump"];
  const prevYear =  stateData[electionState]["result"]["constituency"]["prevYear"]

  // let url = `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/haryana/${consId}.json`;
  //  let url3 = `https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/7047.json`
  // let url2 = `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/haryana-state-master.json`;

  try {
    ctx?.res?.setHeader("Cache-Control", `stale-if-error=86400`);
  } catch (error) {
    console.error("cache error", error);
  }
  try {
    const [res1, res2, res3] = await Promise.allSettled([
      fetch(url).then((data) => data.json()),
      fetch(url3).then((data) => data.json()),
      fetch(url2).then((data) => data.json()),
    ]);

    if (res1.status === "fulfilled") {
      console.log("constituencyListData2019", res1.value?.data);
      ConstituencyListData2019 = res1.value?.data;
    } else {
      console.log("Failed to fetch data from URL 1", res1.reason);
    }

    if (res2.status === "fulfilled") {
      console.log("constituencyListData2024", res2.value?.data);
      ConstituencyListData2024 = res2.value?.data;
    } else {
      console.log("Failed to fetch data from URL 3", res2.reason);
    }

    if (res3.status === "fulfilled") {
      console.log("constituencyArray", res3.value?.data);
      constituencyArray = res3.value?.data;
    } else {
      console.log("Failed to fetch data from URL 2", res3.reason);
    }
  } catch (e) {
    console.log(e);
  }

  return {
    props: {
      consId: consId,
      state: state,
      breadCrump,
      consName: newName,
      stateHindi,
      tabs,
      cYear,
      masterKey,
      electionState,
      prevYear,
      ConstituencyListData2019: ConstituencyListData2019 || [],
      ConstituencyListData2024: ConstituencyListData2024 || [],
      constituencyArray: constituencyArray || [],
    }, // will be passed to the page component as props
  };
}
